import { useEffect } from 'react';
import type { CreditGraph } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

export function useCreditGraph({ url }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<CreditGraph>({
        ...baseConfig,
        url,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

type OptionalHookConfig = {
  url?: string;
};

type ExecuteProps = {
  url: string;
};

export function useOptionalCreditGraph({ url }: OptionalHookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<CreditGraph>({
        ...baseConfig,
        url,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  if (!url) return;

  return request;
}

export type OptionalCreditGraphRequest = ReturnType<
  typeof useOptionalCreditGraph
>;
